
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">
    {{ rootCertificate?.name }}
  </h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="rootCertificate">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!rootCertificate.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  
  <div *ngIf="mode === 'view'" class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="rootCertificate">

    <div *ngIf="mode === 'edit' || mode === 'new'" class="panel">
      <h2>Certificat racine</h2>

      <div *ngIf="mode === 'edit'" class="form-group">
        <label for="name">Nom</label>
        <span id="name" class="value">{{ rootCertificate.name }}</span>
      </div>

      <div class="form-group">
        <label for="pem">PEM</label>
        <textarea #pemInput id="pem" class="code" spellcheck="false" placeholder="" [formControl]="pem" rows="20"></textarea>
        <span class="info info-error" [hidden]="pem.valid || pem.pristine || !pem.errors.required">Ce champ est requis</span>
      </div>

    </div>

    <div class="column" *ngIf="mode === 'view'">

      <div class="panel">
        <h2>Certificat racine</h2>
      
        <div class="form-group">
          <label for="name">Nom</label>
          <span id="name" class="value">{{ rootCertificate.name }}</span>
        </div>

        <div class="form-group">
          <label for="name">PEM</label>
          <span id="name" class="value multiline code">{{ rootCertificate.pem }}</span>
        </div>
      </div>
      
    </div>
    
    <div class="column">

      <div *ngIf="mode === 'view' || mode === 'edit'" class="panel">
        <h2>Autres</h2>
      
        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ rootCertificate.id }}</span>
        </div>
      
        <div class="form-group">
          <label for="createdAt">Date d'ajout</label>
          <span id="createdAt" class="value">{{ rootCertificate.createdAt | tzdate }}</span>
        </div>
      
        <div class="form-group">
          <label for="createdBy">Ajouté par</label>
          <span id="createdBy" class="value">{{ rootCertificate.createdBy.fullname }}</span>
        </div>
      
        <div class="form-group">
          <label for="updatedAt">Date de modification</label>
          <span id="updatedAt" class="value">{{ rootCertificate.updatedAt | tzdate }}</span>
        </div>
      
        <div class="form-group">
          <label for="updatedBy">Modifié par</label>
          <span id="updatedBy" class="value">{{ rootCertificate.updatedBy.fullname }}</span>
        </div>
      </div>

    </div>

  </div>
</form>